import React from 'react';
import * as S from './pix-payment-skeleton.style';

export const PixPaymentPageSkeleton: React.FC = () => {
  return (
    <S.Container>
      <S.ContentWrapper>
        {/* Title */}
        <S.SkeletonTitle />
        <S.SkeletonSubtitle />

        {/* Timer */}
        <S.SkeletonTimerRow className='d-flex justify-content-center align-items-center'>
          <S.SkeletonTextSmall />
          <S.SkeletonTimer />
        </S.SkeletonTimerRow>

        {/* Card */}
        <S.PixCard>
          {/* Status */}
          <S.StatusRow>
            <S.SkeletonCircle />
            <S.SkeletonStatusText />
          </S.StatusRow>

          {/* QR Code */}
          <S.QRCodeContainer>
            <S.QRCodeBox />
          </S.QRCodeContainer>

          {/* Approval */}
          <S.ApprovalRow>
            <S.SkeletonCircleSmall />
            <S.SkeletonApprovalText />
          </S.ApprovalRow>

          {/* Button */}
          <S.ButtonSkeleton />

          {/* Instructions */}
          <S.Instructions>
            <S.SkeletonSectionTitle />
            <S.InstructionLine />
            <S.InstructionLine />
            <S.InstructionLine />
            <S.InstructionLine />
            <S.InstructionLine />
          </S.Instructions>

          {/* Pix Code */}
          <S.CodeBox>
            <S.CodeLabel />
            <S.CodeLine />
            <S.CodeLine />
          </S.CodeBox>
        </S.PixCard>
      </S.ContentWrapper>
    </S.Container>
  );
};
